/* eslint-disable react/prop-types */
import { FormControl, FormLabel, Input, FormErrorMessage } from "@chakra-ui/react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import momentTz from "moment-timezone";

const PickupTime = ({ handleInputChange, data, error, pickupdate, isDisabled }) => {
  const parseTime = (timeStr) => {
    if (!timeStr) return null;
    const [h, m] = timeStr.split(":").map(Number);
    const date = new Date();
    date.setHours(h, m, 0, 0);
    return date;
  };

  const formatTime = (date) => {
    if (!date) return "";
    return momentTz(date).tz("Asia/Kolkata").format("HH:mm");
  };

  const handleChange = (date) => {
    handleInputChange({
      target: { name: "pickuptime", value: formatTime(date) },
    });
  };

  const minTime = () => {
    if (!pickupdate) return parseTime("00:00");
    const today = momentTz().tz("Asia/Kolkata").format("YYYY-MM-DD");
    const pickDate = momentTz(pickupdate, "DD/MM/YYYY").format("YYYY-MM-DD");
    if (pickDate === today) {
      const nearest = momentTz().tz("Asia/Kolkata").add(2, "hours");
      return parseTime(nearest.format("HH:mm"));
    }
    return parseTime("00:00");
  };

  return (
    <FormControl isInvalid={!!error}>
      <FormLabel htmlFor="pickuptime" color="#666">
        Pickup Time
      </FormLabel>
      <DatePicker
        selected={parseTime(data.pickuptime)}
        onChange={handleChange}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={30}
        timeCaption="Time"
        dateFormat="hh:mm aa"
        minTime={minTime()}
        maxTime={parseTime("23:59")}
        customInput={<Input variant="flushed" isDisabled={isDisabled} />}
        placeholderText="Select Time"
        disabled={isDisabled}
      />
      {error && <FormErrorMessage>{error}</FormErrorMessage>}
    </FormControl>
  );
};

export default PickupTime;
